export default __webpack_public_path__ + "147195dc9f844f1d9670a347daa7bc5b.jpg";